import Svg, { Path } from 'react-native-svg'

export const ItemUnChecked = ({ height = 16, width = 16, color = '#B5B5B5' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
        fill={color}
        d="M8 1.334a6.667 6.667 0 0 0-5.16 10.887l9.38-9.38A6.667 6.667 0 0 0 8 1.334Zm5.16 2.447-9.38 9.38a6.667 6.667 0 0 0 9.38-9.38Z"
      />
    </Svg>
  )
}
